
<template>
  <div>
    <div class="product-quantity">
      <div class="qty">{{item.qty}}</div>
      <div class="down" @click="decrement()"></div>
      <div class="up" @click="increment()"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {
      qty: this.quantity
    }
  },
  methods: {
    changeQty () {
      this.$emit('changeQty', this.item)
    },
    increment () {
      if(this.item.stock > this.item.qty) {
        this.item.qty++
        this.changeQty()
      }
    },
    decrement () {
      if (this.item.qty <= 1) {
        this.item.qty = 1
        this.changeQty()
      } else {
        this.item.qty--
        this.changeQty()
      }
    }
  }
}
</script>

<style lang="scss">
.product-quantity {
  width: 120px;
  display: flex;
  height: 30px;
  border: 1px solid $main-color;
  user-select: none;

  @include mq($media-sm) {
    max-width: 375px;
  }

  div {
    flex: 0 0 auto;
    line-height: 30px;
    text-align: center;
    font-size: 22px;
    &:not(:last-child) {
      border-right: 1px solid $main-color;
    }
    &.qty {
      width: 60px;
      font-size: 14px;
    }
    &.up,
    &.down {
      cursor: pointer;
      width: 30px;
      position: relative;
      &:active {
        color: #ffffff;
        background: $main-color;
        &:after,
        &:before {
          background: #fff;
        }
      }

      &:after,
      &:before {
        content: "";
        width: 11px;
        height: 1px;
        background: $main-color;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      &:after {
        transform: rotate(90deg);
      }
    }
    &.down {
      &:after {
        display: none;
      }
    }
  }
}
</style>
